import { GridValidRowModel } from '@microservices/wiskey-react-table-component'

import { isNotEmpty } from '@helpers'
import { CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID_FIELD_NAME } from '@constants'

export interface Row {
  id: string
  isNew: boolean
  [key: string]: any
}

export interface Column {
  field: string
  required?: boolean
}

export const validateNewRows = (
  newRows: GridValidRowModel[],
  requiredFields: string[]
): Record<string, boolean> => {
  const newErrorFields: Record<string, boolean> = {}

  newRows.forEach(row => {
    if (row.isDirty) {
      requiredFields.forEach(field => {
        const value = row[field]
        if (!isNotEmpty(value)) {
          const rowId = row._id ?? row[CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID_FIELD_NAME]
          newErrorFields[`${rowId}.${field}`] = true
        }
      })
    }
  })

  return newErrorFields
}
